export default __webpack_public_path__ + "../staticImages/img-winefinderSprite-2x.png";